import { useRef, useState, useCallback } from 'react';
import '../../utils/responsive.es.js';
import { useDebouncedCallback } from '../../hooks/useDebouncedCallback/useDebouncedCallback.es.js';
import 'body-scroll-lock';
import '../../hooks/useNotification/useNotification.es.js';
import '../../hooks/useToast/useToast.es.js';
import '@popperjs/core';
import '../../utils/assertions.es.js';
import '../../utils/scrollIntoView.es.js';
import 'polished';
import '@styled-system/css';
import 'styled-components';
import { useEnhancedEffect } from '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import 'react-beautiful-dnd';
import 'nanoid/non-secure';

const middleEllipsis = (parentNode, childNode, ellipsis = "...") => {
  const childWidth = childNode.offsetWidth;
  const containerWidth = parentNode.offsetWidth;
  const txtWidth = childNode.offsetWidth;
  const targetWidth = childWidth > txtWidth ? childWidth : txtWidth;
  const ellipsisLength = ellipsis.length + 2;
  if (targetWidth > containerWidth) {
    const str = childNode.textContent || "";
    const txtChars = str.length;
    const avgLetterSize = txtWidth / txtChars;
    const canFit = (containerWidth - (targetWidth - txtWidth)) / avgLetterSize;
    const delEachSide = (txtChars - canFit + ellipsisLength) / 2;
    const endLeft = Math.floor(txtChars / 2 - delEachSide);
    const startRight = Math.ceil(txtChars / 2 + delEachSide);
    childNode.setAttribute("data-original", str);
    childNode.textContent = `${str.substring(0, endLeft)}${ellipsis}${str.substring(startRight)}`;
  }
};
const useTruncate = (props) => {
  const { mode, ellipsis } = props;
  const containerRef = useRef();
  const [isReady, setIsReady] = useState(false);
  const truncateText = useCallback(() => {
    const container = containerRef.current;
    if (mode !== "middle") {
      setIsReady(true);
      return;
    }
    if (!container)
      return;
    const childNode = container == null ? void 0 : container.childNodes[0];
    if (childNode instanceof HTMLElement) {
      if (container == null ? void 0 : container.hasAttribute("title")) {
        childNode.textContent = container == null ? void 0 : container.getAttribute("title");
      }
      middleEllipsis(container, childNode, ellipsis);
      setIsReady(true);
    }
  }, [ellipsis, mode]);
  const debouncedTruncateText = useDebouncedCallback(truncateText, 0);
  useEnhancedEffect(() => {
    if (!(containerRef == null ? void 0 : containerRef.current))
      return;
    setIsReady(false);
    const resizeObserver = new ResizeObserver(debouncedTruncateText);
    resizeObserver.observe(containerRef.current);
    return () => {
      resizeObserver.disconnect();
    };
  }, [truncateText]);
  return { containerRef, isReady };
};

export { middleEllipsis, useTruncate };
//# sourceMappingURL=useTruncate.es.js.map
